export interface IPartnerCommission {
  id: number;
  name: string;
  email: string;
  total_commissions: number;
  total_gain: number;
}

export enum ECustomerSearchTypes {
  NAME = 'commissioned_name',
  EMAIL = 'commissioned_email',
}

export interface IPartnerCommissionFilter {
  commissioned: string;
  commissioned_type: ECustomerSearchTypes;
  date: [string, string];
  created_at?: string;
  created_at_final?: string;
}

export interface IPartnerDetailsCommissions {
  product: {
    id: number;
    title: string;
  };
  total_commissions: number;
  net_gain: number;
}

export interface IPartnerCommissionsDetails {
  commissioned_name: string;
  commissions: IPartnerDetailsCommissions[];
}
